import { ViewProps } from 'react-native';
import KeyWrapper from './key_wrapper';
import { VoidCb } from '../../types/others';

export type Props = {
  enabled?: boolean;
  up?: (keyUp?: boolean) => void;
  down?: (keyUp?: boolean) => void;
  left?: (keyUp?: boolean) => void;
  right?: (keyUp?: boolean) => void;
  confirm?: VoidCb;
  confirmHold?: VoidCb;
  cancel?: VoidCb;
  digit?: (n: number) => void;
  custom?: (key: CustomKey) => void;
  backspace?: VoidCb;
  xSensivity?: number;
  ySensivity?: number;
  upSensivity?: number;
  downSensivity?: number;
  leftSensivity?: number;
  rightSensivity?: number;
  scrollOverride?: VoidCb;
} & Pick<ViewProps, 'onLayout' | 'style' | 'children'>;

export type CustomKey =
  | 'PrevChannel'
  | 'ChannelList'
  | 'ChannelUp'
  | 'ChannelDown'
  | 'PlayPause'
  | 'Play'
  | 'Pause'
  | 'Rewind'
  | 'FForward'
  | 'Zoom';

export default KeyWrapper;
